import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import CloseIcon from '@mui/icons-material/Close';
import { Box, IconButton, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './styles';
export const ErrorMessage = ({ message, messageRef, type = 'Default', withCloseButton, }) => {
    const { t: text } = useTranslation();
    if (messageRef)
        message = text(messageRef);
    const closeBtn = (_jsx(IconButton, { "aria-label": 'close', onClick: withCloseButton, sx: {
            position: 'absolute',
            right: 8,
            top: 8,
        }, children: _jsx(CloseIcon, {}) }));
    return (_jsxs(Box, { children: [type === 'Plain' && (_jsxs(Box, { sx: styles.errorMsg, children: [_jsx(Typography, { variant: 'body2', sx: { ml: 1 }, children: message }), withCloseButton && closeBtn] })), type === 'Default' && (_jsxs(Box, { sx: {
                    backgroundColor: '#fdf3f2',
                    borderRadius: '5px',
                    display: 'flex',
                    alignItems: 'center',
                    p: 2,
                    gap: 2,
                    position: 'relative',
                }, children: [_jsx("img", { src: '/assets/images/error.svg', width: '24px' }), _jsx(Typography, { variant: 'body2', children: message }), withCloseButton && closeBtn] }))] }));
};
